module.exports = __webpack_public_path__ + "media/images/flags/16/British-Antarctic-Territory-ca8f2be8d157604aa723d86b6a40e86f.png";